import { Link } from "react-router-dom";
import type { Drama } from "@/types";

interface DramaCardProps {
  drama: Drama;
}

const statusStyle: Record<string, string> = {
  已完结: "bg-secondary-100 text-secondary-900",
  更新中: "bg-accent-100 text-accent-900",
  即将上线: "bg-primary-100 text-primary-800",
};

const genreStyle = "bg-background-200/80 text-foreground-700";

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-accent-300 cursor-pointer"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={drama.poster}
          alt={`${drama.title} 封面`}
          title={`${drama.title} 剧情介绍与演员名单`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/75 via-primary-950/10 to-transparent"></div>
        <span
          className={`absolute left-3 top-3 rounded-md px-2 py-1 text-[11px] font-medium ${
            statusStyle[drama.status] ?? "bg-secondary-100 text-secondary-900"
          }`}
        >
          {drama.status}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-primary-950/70 px-2 py-1 text-[11px] font-medium text-accent-400">
          <i className="ri-star-fill"></i>
          {drama.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="mb-1.5 flex flex-wrap gap-1.5">
            {drama.genres.slice(0, 2).map((genre) => (
              <span key={genre} className="rounded-full bg-background-50/90 px-2 py-0.5 text-[10px] text-foreground-700">
                {genre}
              </span>
            ))}
          </div>
          <p className="text-sm font-medium text-background-50 line-clamp-1">{drama.title}</p>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-3.5">
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{drama.synopsis}</p>
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1.5 line-clamp-1">
            <i className="ri-user-star-line text-accent-600"></i>
            {drama.cast.slice(0, 2).map((member) => member.name).join(" / ")}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line"></i>
            {drama.year}
          </span>
        </div>
      </div>
    </Link>
  );
}